// extracted by mini-css-extract-plugin
export default {"image":"ImageSearch-module__image_AtSrs"};